import {
  PagePermission,
  TabPermission,
} from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import { Mobile } from '../../mobile.setup';
import {
  MobilePhoneNumberManagementIndividualNumberPortingTab,
  MobilePhoneNumberManagementCorporateNumberPortingTab,
} from './tabs';

const parent = Mobile.pages.phoneNumberManagement;
const title = 'PAGE.MOBILE.PHONE_NUMBER_MANAGEMENT.TITLE';
const tabs: TabPermission[] = [
  MobilePhoneNumberManagementIndividualNumberPortingTab,
  MobilePhoneNumberManagementCorporateNumberPortingTab,
];

export const MobilePhoneNumberManagementPage: PagePermission =
  PermissionsC.generatePagePermission(parent, title, tabs);
